import * as types from '../../types'
import {
    API_URL
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance,
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';
import FileDownload from 'react-file-download';
import moment from 'moment';

export function reiniciarEstado() {
    const axios = createAxiosInstance()
    return (dispatch) => {
        const modelo = 'Solicitud'
        const column = 'nombre_cafeteria'
        const filters = []

        const fn0 = () => axios.post(`${API_URL}/list/values`, {
            modelo,
            filters,
            column,
            orderBy: {
                field: 'nombre_cafeteria',
                direction: 'asc'
            }
        })

        Promise.all([fn0()])
            .then((res) => {
                const list = res[0].data.map(x => {
                    return {
                        caption: x,
                        value: x
                    }
                })
                dispatch({
                    type: 'HYQ3_MODIFY_INPUT_VALUE',
                    payload: {
                        reducer: 'interfazcontable',
                        path: 'cafeterias',
                        value: list
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function getArchivosFromServer(page = 1) {
    const axios = createAxiosInstance()

    return (dispatch, getState) => {
        const modelo = 'Interfaz'
        const include = ['solicitudes']
        const take = 100
        const filter = getState().interfazcontable.getIn(['filter_archivos'])
        const fields = ['nombre', 'solicitudes.nombre_cafeteria']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    group: {
                        id: 9998,
                        glue: 'and'
                    },
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        const data = {
            modelo,
            filters,
            include,
            skip,
            take,
            orderBy: {
                field: 'id',
                direction: 'desc'
            },
            total: true,
        }

        const fn0 = () => axios.post(`${API_URL}/list`, data)

        Promise.all([fn0()])
            .then((res) => {
                const interfaces = res[0].data.data.map(x => {
                    x._enabled = x.procesado ? false : true
                    return x
                })
                const records = res[0].data.total
                dispatch(tableActions.mswTable_mostrarDatos('interfazcontable', 'interfaces', interfaces, 1, records))
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function getDataFromServer(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'Solicitud'
        const include = ['solicitante', 'detalles', 'distribuciones.cenco.aprobador']
        const take = 100
        const cafeteria = getState().interfazcontable.getIn(['cafeteria']) || false
        const filter = getState().interfazcontable.getIn(['filter'])
        const fields = ['evento_actividad', 'nombre_cafeteria', 'fecha_hora', 'lugar', 'estado', 'solicitante.name', 'distribuciones.cenco.codigo']
        const filters = [{
            group: {
                id: 9999,
                glue: 'and'
            },
            field: 'nombre_cafeteria',
            operator: '=',
            value: cafeteria,
            andOr: 'and'
        }]

        if (!cafeteria) {
            displayMessages(dispatch, {
                success: 'Seleccione una cafetería para consultar la información'
            })
            return
        }

        if (filter) {
            fields.forEach(x => {
                let f = {
                    group: {
                        id: 9998,
                        glue: 'and'
                    },
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        const data = {
            modelo,
            filters,
            include,
            skip,
            take,
            orderBy: {
                field: 'id',
                direction: 'desc'
            },
            total: true,
        }

        axios.post(`${API_URL}/interfaz-contable/solicitudes`, data)
            .then((res) => {
                const list = res.data.data.map(x => {
                    x._enabled = true
                    return x
                })
                const records = res.data.total
                dispatch(tableActions.mswTable_mostrarDatos('interfazcontable', 'interfazcontable', list, page, records))
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function showHideModalGenerateInterfaz(show) {
    return (dispatch, getState) => {
        const solicitudes = getState().interfazcontable.getIn('interfazcontable.data'.split('.')).valueSeq().filter(x => x.get('selected')).map(x => x.get('id')).toList()
        if (solicitudes.count() === 0) {
            displayMessages(dispatch, {
                response: {
                    status: 500,
                    data: {
                        Exception: 'EMPTY_ARRAY',
                        Message: 'No seleccionó ninguna solicitud para ser procesada',
                        Trace: null
                    }
                },
            });
            return
        }
        dispatch({
            type: types.INTERFAZCONTABLE_MOSTRAR_MODAL_GENERAR_INTERFAZ,
            payload: {
                show,
                solicitudes
            }
        })
    }
}

export function generateInterfaz() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        if (getState().interfazcontable.get('saving')) return
        dispatch(setSavingState('interfazcontable', true))

        const consecutivo = getState().interfazcontable.getIn('modalGenerateInterfaz.data.consecutivo'.split('.'))
        const notas = getState().interfazcontable.getIn('modalGenerateInterfaz.data.notas'.split('.'))
        const solicitudes = getState().interfazcontable.getIn('interfazcontable.data'.split('.')).valueSeq().filter(x => x.get('selected')).map(x => x.get('id')).toList()
        const data = {
            consecutivo,
            notas,
            solicitudes,
            filename: `interfaz-${moment().format('YYYYMMDDHHmm')}.txt`
        }
        axios.post(`${API_URL}/interfaz-contable`, data, {
                responseType: 'arraybuffer'
            })
            .then((res) => {
                FileDownload(res.data, data.filename);
                dispatch(showHideModalGenerateInterfaz(false))
                dispatch(getDataFromServer())
                dispatch(setSavingState('interfazcontable', false))
            })
            .catch((err) => {
                let obj
                if (err.response && err.response.data) {
                    const {
                        data,
                        status
                    } = err.response;
                    const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
                    obj = {
                        response: {
                            data: decodedString,
                            status
                        }
                    };
                } else {
                    obj = err
                }
                console.log(err)
                displayMessages(dispatch, obj);
                dispatch(setSavingState('interfazcontable', false))
            })
    }
}

export function deleteArchivosInterfaz() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const toDelete = getState().interfazcontable.getIn('interfaces.data'.split('.')).valueSeq().filter(x => x.get('selected')).map(x => x.get('id')).toList()
        axios.put(`${API_URL}/interfaz-contable`, toDelete)
            .then((res) => {
                dispatch(getArchivosFromServer())
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err);
            })
    }
}

export function archiveArchivosInterfaz() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const toArchive = getState().interfazcontable.getIn('interfaces.data'.split('.')).valueSeq().filter(x => x.get('selected')).map(x => x.get('id')).toList()
        axios.patch(`${API_URL}/interfaz-contable`, toArchive)
            .then((res) => {
                dispatch(getArchivosFromServer())
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err);
            })
    }
}